/**
 * Abwesenheits-Gruende: Labels + konsistente Farbzuordnung (10 feste Farben).
 *
 * Farbschema (Vorgabe): URLAUB blau, KRANK gelb, UNENTSCHULDIGT rot,
 * FREI_NACH_MTV gruen, RUECKRUF orange, FREISCHICHT teal, ALTERSFREIZEIT
 * violett, KURZARBEIT grau, UNBEZAHLTER_URLAUB slate, KUR pink.
 */

import type { AbsenceStatus, AbwesenheitGrund } from "@/types"

interface ReasonStyle {
  label: string
  /** Tailwind-Klassen fuer Badges (heller Hintergrund + dunkle Schrift) */
  badge: string
  /** Tailwind-Klasse fuer Kalender-Balken (satte Farbe) */
  bar: string
}

export const ABSENCE_REASONS: Record<AbwesenheitGrund, ReasonStyle> = {
  URLAUB: {
    label: "Urlaub",
    badge: "border-blue-300 bg-blue-100 text-blue-800",
    bar: "bg-blue-500",
  },
  KRANK: {
    label: "Krank",
    badge: "border-yellow-300 bg-yellow-100 text-yellow-800",
    bar: "bg-yellow-400",
  },
  UNENTSCHULDIGT: {
    label: "Unentschuldigt",
    badge: "border-red-300 bg-red-100 text-red-800",
    bar: "bg-red-500",
  },
  FREI_NACH_MTV: {
    label: "Frei nach MTV",
    badge: "border-green-300 bg-green-100 text-green-800",
    bar: "bg-green-500",
  },
  RUECKRUF: {
    label: "Rückruf",
    badge: "border-orange-300 bg-orange-100 text-orange-800",
    bar: "bg-orange-500",
  },
  FREISCHICHT: {
    label: "Freischicht",
    badge: "border-teal-300 bg-teal-100 text-teal-800",
    bar: "bg-teal-500",
  },
  ALTERSFREIZEIT: {
    label: "Altersfreizeit",
    badge: "border-violet-300 bg-violet-100 text-violet-800",
    bar: "bg-violet-500",
  },
  KURZARBEIT: {
    label: "Kurzarbeit",
    badge: "border-gray-300 bg-gray-100 text-gray-800",
    bar: "bg-gray-500",
  },
  UNBEZAHLTER_URLAUB: {
    label: "Unbezahlter Urlaub",
    badge: "border-slate-300 bg-slate-200 text-slate-800",
    bar: "bg-slate-500",
  },
  KUR: {
    label: "Kur",
    badge: "border-pink-300 bg-pink-100 text-pink-800",
    bar: "bg-pink-500",
  },
}

/** Alle Gruende in fester Reihenfolge (fuer Selects/Legenden) */
export const ABSENCE_REASON_VALUES = Object.keys(ABSENCE_REASONS) as AbwesenheitGrund[]

export const ABSENCE_STATUS_LABEL: Record<AbsenceStatus, string> = {
  BOOKED: "Gebucht",
  PENDING: "Beantragt",
  APPROVED: "Genehmigt",
  REJECTED: "Abgelehnt",
  CANCELLED: "Storniert",
}

/** Status-Badges des Urlaubsworkflows (PENDING gelb, APPROVED gruen, REJECTED rot, CANCELLED grau) */
export const ABSENCE_STATUS_BADGE: Record<AbsenceStatus, string> = {
  BOOKED: "border-blue-300 bg-blue-100 text-blue-800",
  PENDING: "border-yellow-300 bg-yellow-100 text-yellow-800",
  APPROVED: "border-green-300 bg-green-100 text-green-800",
  REJECTED: "border-red-300 bg-red-100 text-red-800",
  CANCELLED: "border-gray-300 bg-gray-100 text-gray-600",
}
